import {
  FileMetaDataDto,
  FormBaseType,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_UPLOADS_METADATA = "GET_UPLOADS_METADATA";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

interface GetUploadsMetadataRequest {
  formBaseType: FormBaseType;
}

export const getUploadsMetadata = async (
  params: GetUploadsMetadataRequest,
): Promise<FileMetaDataDto[]> => {
  const response = await formsApi.formsControllerGetUploadsMetaData(
    params.formBaseType,
  );

  return response.data;
};

export const useGetUploadsMetadata = (
  user: UserProfileDto | null,
  params: GetUploadsMetadataRequest,
): {
  uploadsMetadata?: FileMetaDataDto[];
  uploadsMetadataEnabled: boolean;
  isLoadingUploads: boolean;
  isFetchingUploads: boolean;
  isSuccessUploads: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const { data, isLoading, isFetching, isSuccess } = useQuery({
    queryKey: [DOMAIN_FORMS, ACTION_GET_UPLOADS_METADATA, params],
    queryFn: () => getUploadsMetadata(params),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    uploadsMetadata: data,
    uploadsMetadataEnabled: enabled,
    isLoadingUploads: isLoading,
    isFetchingUploads: isFetching,
    isSuccessUploads: isSuccess,
  };
};
